import React from 'react'
import styled from 'styled-components'
import { Tooltip } from '@mui/material'
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined'

const CONFIG = {
  sharepoint: { label: 'SharePoint', Icon: CloudSyncOutlinedIcon, bg: '#eaf1fe', fg: '#3b5ba5', hint: 'Synced from SharePoint' },
  email: { label: 'Email', Icon: EmailOutlinedIcon, bg: '#eef2ff', fg: '#4f46e5', hint: 'Received by email' },
  upload: { label: 'Uploaded', Icon: UploadFileOutlinedIcon, bg: '#eef2f7', fg: '#475569', hint: 'Uploaded on the platform' }
}

const ProvenanceChip = ({ provenance }) => {
  const c = CONFIG[provenance] || CONFIG.upload
  const Icon = c.Icon
  return (
    <Tooltip title={c.hint} placement='top' arrow>
      <Chip $bg={c.bg} $fg={c.fg}>
        <Icon style={{ fontSize: 13 }} /> {c.label}
      </Chip>
    </Tooltip>
  )
}

export default ProvenanceChip

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background: ${({ $bg }) => $bg};
  color: ${({ $fg }) => $fg};
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
`
